<template>
  <v-card outlined>
    <v-data-table
      :headers="headers"
      :items="rows"
      :loading="loading"
      item-key="key"
      class="elevation-0 pointer-rows"
      :no-data-text="$t('general.noData')"
      :items-per-page="-1"
      :footer-props="{ itemsPerPageOptions: [-1, 10, 25, 50] }"
      @click:row="$emit('open', $event)"
    >
      <template v-slot:item.label="{ item }">
        <v-icon left color="primary">mdi-folder</v-icon>
        {{ item.label }}
      </template>

      <template v-slot:item.total="{ item }">
        <v-chip color="primary" outlined class="px-4">
          {{ item.total }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: "dateFolderTable",
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    nameLabel: { type: String, default: "" },
  },
  computed: {
    headers() {
      return [
        {
          text: this.nameLabel || this.$t("folderCount.total"),
          value: "label",
          align: "left",
        },
        {
          text: this.$t("folderCount.total"),
          value: "total",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style scoped>
.pointer-rows >>> tbody tr {
  cursor: pointer;
}
</style>
